"use client";

import { createContext, useContext } from "react";
import { SuggestionItem } from "@/types/suggestions";
export interface ChatSuggestionsContextValue {
  suggestions: SuggestionItem[];
}
export const ChatSuggestionsContext = createContext<ChatSuggestionsContextValue | null>(null);
export function useChatSuggestionsContext() {
  const context = useContext(ChatSuggestionsContext);
  if (!context) {
    throw new Error("useChatSuggestionsContext must be used within a ChatSuggestionsProvider");
  }
  return context;
}